import { ReactNode, TableHTMLAttributes } from 'react';
import { NotFoundIcon } from 'static/icons';
import { Heading } from 'components/heading';
import { Tooltip } from 'components/tooltip';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

type TableHeaderCell = {
  name: string;
  description?: string | ReactNode;
  icon?: ReactNode;
};

interface Props extends TableHTMLAttributes<HTMLTableElement> {
  headers: TableHeaderCell[];
  noResults: boolean;
  hasMinWidth?: boolean;
}

export function Table({
  children,
  headers,
  noResults,
  hasMinWidth = true,
  ...rest
}: Props) {
  function renderHeaderWithTooltip({
    name,
    description,
    icon,
  }: {
    name: string;
    description: string | ReactNode;
    icon?: ReactNode;
  }) {
    return (
      <th key={name}>
        {icon ? (
          <div className="flex items-center gap-1">
            {name}
            <Tooltip message={description}>{icon}</Tooltip>
          </div>
        ) : (
          <Tooltip message={description}>
            <div className="flex items-center gap-1">{name}</div>
          </Tooltip>
        )}
      </th>
    );
  }

  return (
    <S.TableWrapper>
      <S.TableContainer>
        <S.Table $hasMinWidth={hasMinWidth} {...rest}>
          <thead>
            <tr>
              {headers.map(({ name, description, icon }) => {
                return description ? (
                  renderHeaderWithTooltip({ name, description, icon })
                ) : (
                  <th key={name}>{name}</th>
                );
              })}
            </tr>
          </thead>

          {!noResults && <tbody>{children}</tbody>}
        </S.Table>
      </S.TableContainer>

      {noResults && (
        <S.Wrapper>
          <NotFoundIcon />

          <Heading as="h3" size={FontSize.font20} weight={FontWeight.bold}>
            Sem resultados
          </Heading>
        </S.Wrapper>
      )}
    </S.TableWrapper>
  );
}
